import React, { useState, useEffect } from 'react';
import { Container, Table } from 'react-bootstrap';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import "../Plan/Plan.css";

const CheckSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <mask id="mask0_16_3641" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
      <rect x="0.833374" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16_3641)">
      <path d="M10.3833 18.0001L4.68335 12.3001L6.10835 10.8751L10.3833 15.1501L19.5584 5.9751L20.9834 7.4001L10.3833 18.0001Z" fill="#016EBD" />
      <path d="M10.3833 18.0001L4.68335 12.3001L6.10835 10.8751L10.3833 15.1501L19.5584 5.9751L20.9834 7.4001L10.3833 18.0001Z" fill="#8612D2" />
      <path d="M10.3833 18.0001L4.68335 12.3001L6.10835 10.8751L10.3833 15.1501L19.5584 5.9751L20.9834 7.4001L10.3833 18.0001Z" fill="#009BF9" />
    </g>
  </svg>
);

const CheckSVG2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <mask id="mask0_16_6022" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
      <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16_6022)">
      <path d="M10.05 18.0001L4.34998 12.3001L5.77498 10.8751L10.05 15.1501L19.225 5.9751L20.65 7.4001L10.05 18.0001Z" fill="#8612D2" />
      <path d="M10.05 18.0001L4.34998 12.3001L5.77498 10.8751L10.05 15.1501L19.225 5.9751L20.65 7.4001L10.05 18.0001Z" fill="#8612D2" />
      <path d="M10.05 18.0001L4.34998 12.3001L5.77498 10.8751L10.05 15.1501L19.225 5.9751L20.65 7.4001L10.05 18.0001Z" fill="#8612D2" />
    </g>
  </svg>
);

const Cross = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <mask id="mask0_16_3698" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
      <rect x="0.833374" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16_3698)">
      <path d="M7.23337 19L5.83337 17.6L11.4334 12L5.83337 6.4L7.23337 5L12.8334 10.6L18.4334 5L19.8334 6.4L14.2334 12L19.8334 17.6L18.4334 19L12.8334 13.4L7.23337 19Z" fill="#BFBFBF" />
    </g>
  </svg>
);

const ResponsiveTable = ({ planssubtitle, planssectiontitle }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const headers = [
    { title: 'Lite', subtitle: 'Free', button: 'Start for free', titleColor: 'blue', buttonBackground: 'blue-gradient' },
    { title: 'Team', subtitle: '$9.99/mo', button: 'Get started', titleColor: 'purple', buttonBackground: 'purple-gradient' },
    { title: 'Enterprise', subtitle: '$29.99/mo', button: 'Get started', titleColor: 'purple', buttonBackground: 'purple-gradient' },
  ];

  const data = [
    { info: 'Cloud Service scanning', number: '1', number2: '25', number3: '100', month: ' /month', month2: ' /month', month3: ' /month', numberColor: 'blue', numberColor2: 'purple', numberColor3: 'purple', },
    { info: 'Website Scans', number: '1', number2: '25', number3: '100', month: ' /month', month2: ' /month', month3: ' /month', numberColor: 'blue', numberColor2: 'purple', numberColor3: 'purple', },
    { info: 'Network Scans', number: '1', number2: '25', number3: '100', month: ' /month', month2: ' /month', month3: ' /month', numberColor: 'blue', numberColor2: 'purple', numberColor3: 'purple', },
    {
      info: `Automated Vulnerability Assessment reports`, number: <CheckSVG />, number2: <CheckSVG2 />, number3: <CheckSVG2 />,
    },
    { info: 'Scan Internal Network', number: <Cross />, number2: <CheckSVG2 />, number3: <CheckSVG2 /> },
    { info: 'Authenticated scans', number: <Cross />, number2: <CheckSVG2 />, number3: <CheckSVG2 /> },
    { info: 'Multi User access', number: <Cross />, number2: <CheckSVG2 />, number3: <CheckSVG2 /> },
    { info: 'Manual PT findings', number: <Cross />, number2: <CheckSVG2 />, number3: <CheckSVG2 /> },
    { info: 'Choice of Scanning Engine', number: <Cross />, number2: <CheckSVG2 />, number3: <CheckSVG2 /> },
    {
      info: `CREST certified Testers`, number: <Cross />, number2: <CheckSVG2 />, number3: <CheckSVG2 />
    },
    { info: `Scheduled scans`, number: <Cross />, number2: <CheckSVG2 />, number3: <CheckSVG2 /> },
    { info: 'White Label reports', number: <Cross />, number2: <Cross />, number3: <CheckSVG2 /> },
    { info: 'API access', number: <Cross />, number2: <Cross />, number3: <CheckSVG2 /> },
    { info: 'SSO', number: <Cross />, number2: <Cross />, number3: <CheckSVG2 /> },
    { info: 'Dedicated Account Manager', number: <Cross />, number2: <Cross />, number3: <CheckSVG2 /> },
    { info: 'Additional payment methods', number: <Cross />, number2: <Cross />, number3: <CheckSVG2 /> },
    { info: 'Slack integration', number: <Cross />, number2: <Cross />, number3: <CheckSVG2 /> },
  ];

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />
  };

  return (
    <div className='plans-section' id='plan'>
      <Container>
        <div className='plans-content'>
          <div className='sub-title'>
            <span>{planssubtitle}</span>
          </div>
          <div className='section-title'>
            <h2>{planssectiontitle}</h2>
          </div>
          <div className='table-block'>
            {!isMobile ? (
              <Table>
                <thead>
                  <tr>
                    <th></th>
                    {headers.map((header, index) => (
                      <th key={index}>
                        <span className={`category-title color-${header.titleColor}`}>{header.title}</span>
                        <span className='category-sub-title'>{header.subtitle}</span>
                        <Link to="/" className={`category-button btn btn-blue bg-${header.buttonBackground}`}>{header.button}</Link>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={headers.length + 1} className="styled-tbody-container">
                      <div className="styled-tbody">
                        {data.map((row, index) => (
                          <div className="styled-tbody-row" key={index}>
                            <span className='row-info'>{row.info}</span>
                            <p className={`number color-${row.numberColor}`}>{row.number}<span>{row.month}</span></p>
                            <p className={`number color-${row.numberColor2}`}>{row.number2}<span>{row.month2}</span></p>
                            <p className={`number color-${row.numberColor3}`}>{row.number3}<span>{row.month3}</span></p>
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            ) : (
              <Slider {...settings}>
                {headers.map((header, headerIndex) => (
                  <div key={headerIndex} className="slider-item">
                    <div className="slider-header">
                      <span className={`category-title color-${header.titleColor}`}>{header.title}</span>
                      <span className='category-sub-title'>{header.subtitle}</span>
                      <Link to="/" className={`category-button btn btn-blue bg-${header.buttonBackground}`}>{header.button}</Link>
                    </div>
                    {data.map((row, rowIndex) => (
                      <div key={rowIndex} className="slider-content-row">
                        <span className='row-info'>{row.info}</span>
                        {headerIndex === 0 && (
                          <p className={`number color-${row.numberColor}`}>{row.number}<span>{row.month}</span></p>
                        )}
                        {headerIndex === 1 && (
                          <p className={`number color-${row.numberColor2}`}>{row.number2}<span>{row.month2}</span></p>
                        )}
                        {headerIndex === 2 && (
                          <p className={`number color-${row.numberColor3}`}>{row.number3}<span>{row.month3}</span></p>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </Slider>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow next-arrow`}
      style={{ ...style }}
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
        <path d="M8.37461 6.67139L2.37461 12.6714L0.974609 11.2714L5.57461 6.67139L0.974609 2.07139L2.37461 0.671387L8.37461 6.67139Z" fill="white" />
      </svg>
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow prev-arrow`}
      style={{ ...style }}
      onClick={onClick}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
        <path d="M0.625391 6.67139L6.62539 0.671387L8.02539 2.07139L3.42539 6.67139L8.02539 11.2714L6.62539 12.6714L0.625391 6.67139Z" fill="white" />
      </svg>
    </div>
  );
};

export default ResponsiveTable;


